import React, { useEffect, useState } from 'react';
import { Clock } from 'lucide-react';
export function CountdownTimer() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 0,
    minutes: 0,
    seconds: 0
  });
  useEffect(() => {
    const calculateTimeLeft = () => {
      const now = new Date();
      const endOfDay = new Date();
      endOfDay.setHours(23, 59, 59, 999);
      const difference = endOfDay.getTime() - now.getTime();
      if (difference > 0) {
        setTimeLeft({
          hours: Math.floor(difference / (1000 * 60 * 60) % 24),
          minutes: Math.floor(difference / 1000 / 60 % 60),
          seconds: Math.floor(difference / 1000 % 60)
        });
      }
    };
    calculateTimeLeft();
    const timer = setInterval(calculateTimeLeft, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatNumber = (num: number) => num.toString().padStart(2, '0');
  return <div className="flex flex-col items-center justify-center mb-8 w-full" data-id="element-49">
      <div className="flex items-center gap-2 text-red-600 font-bold mb-3 uppercase tracking-wider text-sm md:text-base animate-pulse bg-red-50 px-3 py-1 rounded-full" data-id="element-50">
        <Clock className="w-4 h-4" data-id="element-51" />
        <span data-id="element-52">¡Oferta termina hoy! Quedan:</span>
      </div>

      <div className="flex gap-2 md:gap-4 text-center" data-id="element-53">
        <div className="flex flex-col" data-id="element-54">
          <div className="bg-red-500 text-white font-black text-2xl md:text-4xl px-3 py-3 rounded-xl shadow-lg min-w-[60px] md:min-w-[80px] border-b-4 border-red-700" data-id="element-55">
            {formatNumber(timeLeft.hours)}
          </div>
          <span className="text-xs text-gray-500 mt-2 font-bold uppercase tracking-wider" data-id="element-56">
            Horas
          </span>
        </div>

        <div className="text-2xl md:text-4xl font-black text-gray-300 py-2 self-start mt-2" data-id="element-57">
          :
        </div>

        <div className="flex flex-col" data-id="element-58">
          <div className="bg-red-500 text-white font-black text-2xl md:text-4xl px-3 py-3 rounded-xl shadow-lg min-w-[60px] md:min-w-[80px] border-b-4 border-red-700" data-id="element-59">
            {formatNumber(timeLeft.minutes)}
          </div>
          <span className="text-xs text-gray-500 mt-2 font-bold uppercase tracking-wider" data-id="element-60">
            Minutos
          </span>
        </div>

        <div className="text-2xl md:text-4xl font-black text-gray-300 py-2 self-start mt-2" data-id="element-61">
          :
        </div>

        <div className="flex flex-col" data-id="element-62">
          <div className="bg-red-500 text-white font-black text-2xl md:text-4xl px-3 py-3 rounded-xl shadow-lg min-w-[60px] md:min-w-[80px] border-b-4 border-red-700" data-id="element-63">
            {formatNumber(timeLeft.seconds)}
          </div>
          <span className="text-xs text-gray-500 mt-2 font-bold uppercase tracking-wider" data-id="element-64">
            Segundos
          </span>
        </div>
      </div>
    </div>;
}